import { render } from "./modal.widget.vue?vue&type=template&id=4d9a57d7&ts=true"
import script from "./modal.widget.vue?vue&type=script&lang=ts"
export * from "./modal.widget.vue?vue&type=script&lang=ts"

import "./modal.widget.vue?vue&type=style&index=0&id=4d9a57d7&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/miyo-prod/ftrc-prd/src/project/fotile-riskctl/code/frontend/mgr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__